import { render, staticRenderFns } from "./IconDocumentOutline.vue?vue&type=template&id=408c0ac4"
import script from "./IconDocumentOutline.vue?vue&type=script&lang=js"
export * from "./IconDocumentOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports